import { Component } from 'react';
import {GoogleApiWrapper, InfoWindow, Map, Marker} from 'google-maps-react';
import { Card, Col, Container, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import {API_KEY, initialCenter} from '../../../../data/googleMap';
import {getOutletMapFeatureCollection, getOutletRBMCodes} from '../../../../actions/outlet';
import green from '../../../../assets/img/green.png';
import red from '../../../../assets/img/red.png';
import {fromAddress} from '../../../../utils/geoCode';
import ToastMessage from '../../../common/toast-message';
import ArrowButton from '../../../common/button-arrow';
import PageTitle from '../../../common/page-title/index';
import Can from '../../../common/guards/can';
import {currentUserGroup} from '../../../../utils/tokenUtils';
import UserGroupGuard from '../../../common/guards/user-group';

import './map.css';
import {GROUP_IT, GROUP_SUPER} from '../../../../data/userGroups';

const markerIcons = {
  green,
  red
};

export class MapContainer extends Component {
  state = {
    name: '',
    title: '',
    info: false,
    infoPosition: null,
    center: initialCenter,
    address: '',
  };
  onInfoWindowClose = () => {
    this.setState({info: false});
  };
  onInfoWindowOpen = () => {
  };
  onMarkerClick = (position, name, id) => {
    this.setState({
      info: true,
      infoPosition: position,
      name,
      id
    });
  };
  onRBMChange = (event) => {
    const {value} = event.target;
    const {dispatch} = this.props;
    if (value && value.length) {
      dispatch(getOutletMapFeatureCollection(value));
    } else {
      dispatch(getOutletMapFeatureCollection());
    }
  };
  onAddressKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.relocate();
    }
  };
  changeAddress = (event) => {
    this.setState({
      address: event.target.value
    });
  };
  relocate = () => {
    fromAddress(this.state.address)
      .then(
        (response) => {
          this.setState({center: response.results[0].geometry.location});
        },
        () => {
          toast.error(<ToastMessage iconStyle="error" message="No location result"/>);
        }
      );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {dispatch, group} = this.props;
    if (!group && nextProps.group) {
      if ([GROUP_IT, GROUP_SUPER].includes(nextProps.group)) {
        dispatch(getOutletRBMCodes());
      }
    }
  }

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getOutletMapFeatureCollection());
  }

  render() {
    const {google, markers, rbmCodes} = this.props;
    const {
      id, name, info, infoPosition, center, address
    } = this.state;
    const bounds = new google.maps.LatLngBounds();

    (markers || []).forEach((marker) => {
      bounds.extend({
        lat: marker.geometry.coordinates[0],
        lng: marker.geometry.coordinates[1]
      });
    });

    return (
      <Container fluid>
        <Row>
          <Col lg={12}>
            <PageTitle>
              My stores
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
              <UserGroupGuard type={[GROUP_IT, GROUP_SUPER]}>
                <Can action="manage" subjectClass="Outlet">
                  <FormGroup controlId="formControlsSelect">
                    <FormLabel>
                      Filter by RBM code
                    </FormLabel>
                    <FormControl as="select" defaultValue={''} onChange={this.onRBMChange}>
                      <option value=""/>
                      {rbmCodes.map((rbm => (
                        <option key={rbm} value={rbm}>
                          {rbm}
                        </option>
                      )))}
                    </FormControl>
                  </FormGroup>
                </Can>
              </UserGroupGuard>
              <FormLabel>
                Search by location
              </FormLabel>
              <div className="input-group">
                <input
                  className="form-control"
                  onBlur={this.relocate}
                  onChange={this.changeAddress}
                  onKeyPress={this.onAddressKeyPress}
                  placeholder="Search for location e.g.: London, SW1"
                  value={address}
                />
                <ArrowButton className="google-search-button" color="grey">
                  Search
                </ArrowButton>
              </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mg-top-30">
          <Col lg={12} style={{height: 500}}>
            <Card className="google-map-panel">
              <Card.Body>
              <Map center={center} google={google} initialCenter={initialCenter} zoom={6}>

                {(markers || []).map((marker, key) => (
                  <Marker
                    icon={{
                      url: markerIcons[marker.properties.icon],
                    }}
                    key={key}
                    name={marker.properties.outlet_name}
                    onClick={(triggeredMarker) => {
                      this.onMarkerClick(
                        triggeredMarker.position,
                        triggeredMarker.name,
                        marker.properties.outlet_id
                      );
                    }}
                    position={{
                      lat: marker.geometry.coordinates[0],
                      lng: marker.geometry.coordinates[1]
                    }}
                  />
                ))}

                <InfoWindow onClose={this.onInfoWindowClose} onOpen={this.onInfoWindowOpen} position={infoPosition} visible={info}>
                  <a className="text-uppercase" href={`/team/outlets/${id}`}>
                    {name}
                  </a>
                </InfoWindow>
              </Map>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mg-top-30">
          <Col lg={12}>
            <Card>
              <Card.Body>
              <ul style={{listStyleType: 'none'}}>
                <li>
                  <img alt="Marker2" className="mg-right-10" src={red}/>
                  Unclaimed store
                </li>
                <li>
                  <img alt="Marker3" className="mg-right-10" src={green}/>
                  Claimed store
                </li>
              </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  markers: state.stores.markers,
  rbmCodes: state.stores.rbmCodes,
  rbmLoading: state.stores.rbmLoading,
  group: currentUserGroup(),
});

const googleApiSettings = {
  apiKey: API_KEY
};

export default connect(mapStateToProps)(GoogleApiWrapper(googleApiSettings)(MapContainer));
